import Img from "components/Commons/Image/Image"
import ProductDetail from "components/Core/ProductBase/ProductDetail"
import SummaryProductCardStyled from "components/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.styled"
import { useGetProductInfoByClient } from "hooks/UseGetMultiClient"
import { IProcessItem } from "interfaces/IItemsOrder"
import { IconCheck, IconReject } from "theme/common/Icon.styled"

const SummaryProductCard = ({
  itemOrder,
  hasIcon = false,
}: {
  itemOrder: IProcessItem
  hasIcon?: boolean
}) => {
  const productFields = useGetProductInfoByClient(itemOrder)
  return (
    <SummaryProductCardStyled hasIcon={hasIcon} isConfirm={itemOrder.isConfirm}>
      <p className="item-name">{itemOrder.name}</p>
      <div className="body-product-card">
        <div className="info-tem">
          <ProductDetail fields={productFields} hasPlaceHolder={false} />
        </div>

        {itemOrder.custom?.thumbnail && (
          <Img url={itemOrder.custom.thumbnail} alt={itemOrder.name} />
        )}
        {hasIcon ? itemOrder.isConfirm ? <IconCheck /> : <IconReject /> : null}
      </div>
    </SummaryProductCardStyled>
  )
}

export default SummaryProductCard
